import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

import './index.scss';
import { TextContentComponent } from '@myriadgenetics/mgh-types';

type TcRiskScoreProps = {
  type: 'TEXT_CONTENT';
  compDef: TextContentComponent;
  overThreshold?: boolean;
  responses: any;
};

export function TcRiskScore(props: TcRiskScoreProps) {
  const { t } = useTranslation();
  const lifeTimeRisk: number = props.responses?.surveyEntrySave?.responses?.tcResult?.remaining_lifetime_risk;
  const fiveYearRisk: number = props.responses?.surveyEntrySave?.responses?.tcResult?.five_year_risk;
  const shouldShowElevatedRisk = lifeTimeRisk >= 0.2;

  const toPercent = (risk: number) => {
    return (risk * 100).toFixed(1) + '%';
  };

  if (props.compDef.data.contentKey === 'results.tcComponent.title' && lifeTimeRisk !== undefined && fiveYearRisk !== undefined) {
    return (
      <div className="tc-banner">
        {shouldShowElevatedRisk && (
          <div className="tc-banner__over-threshold">
            <FontAwesomeIcon size="sm" icon={faArrowUp} aria-hidden /> {t('results.tcComponent.elevatedRisk')}
          </div>
        )}
        <div className={'tc-banner__title'}>{t('results.tcComponent.title')}</div>
        <div className={'tc-banner__risk'}>
          {t('results.tcComponent.lifeTimeRisk')}
          <span className="tc-banner__risk-score">{toPercent(lifeTimeRisk)}</span>
        </div>
        <div className={'tc-banner__risk'}>
          {t('results.tcComponent.fiveYearRisk')}
          <span className="tc-banner__risk-score">{toPercent(fiveYearRisk)}</span>
        </div>
      </div>
    );
  }
  return null;
}

export default TcRiskScore;
